import { z } from 'zod';

import { COUPON_COPY } from '@assets/constants/coupons';

// TODO(promo-codes): Confirm date-only expiration time and timezone rules.
// The shared DatePicker's selected instant is serialized as ISO; no start/end-of-day rule is added.
const timestampScheme = z.union([z.literal(''), z.iso.datetime({ offset: true })]);

export const promoCodeScheme = z
  .object({
    code: z
      .string()
      .regex(
        /^[A-Za-z0-9][A-Za-z0-9_-]{1,63}$/,
        'Use 2–64 letters, digits, underscores or hyphens.'
      ),
    display_name: z.string().min(1, 'Please fill in name').max(255),
    nominal_amount: z
      .string()
      .regex(/^-?\d{1,10}(?:\.\d{1,2})?$/, 'Enter an amount with up to 2 decimal places.'),
    total_activations: z
      .string()
      .regex(/^\d+$/, 'Enter a whole number.')
      .refine(
        (value) => Number(value) >= 1 && Number(value) <= 1000000,
        'Quantity must be between 1 and 1000000.'
      ),
    currency: z.string().regex(/^[A-Za-z]{3}$/, 'Enter a three-letter currency code.'),
    starts_at: timestampScheme,
    expires_at: timestampScheme,
    notes: z.string().max(2000),
  })
  .refine(
    ({ starts_at, expires_at }) =>
      !starts_at || !expires_at || new Date(expires_at).getTime() >= new Date(starts_at).getTime(),
    { path: ['expires_at'], message: COUPON_COPY.expirationBeforeStart }
  );

export type PromoCodeFormValues = z.infer<typeof promoCodeScheme>;
